import Vue from 'vue'
import Vuex from 'vuex'
import firebase from './firebaseConfig.js'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: "Sylvain Becquart",
    arrowHelper: true,
    dialogItem: {},
    dialogLogin: false,
    user: null,
    userBuffer: null,
    imagesSceleton: true,
    loading: false,
    userVersion: 0.23,
    version: 0,
    snackbar: { active: false, color: "", mode: "", timeout: 0, text: "" },
    huiles: [],
    dessins: [],
    atelier: [],
    artists: [],
    categories: ["huiles", "dessins", "atelier", "artists"],
    lastVisible: { huiles: 3, dessins: 3, atelier: 3, artists: 3 },
    browser: null,
  },
  mutations: {
    setDateItem(state, val) {
      state.dateItem = val
    },
    setUser(state, val) {
      state.user = val
    },
    setVersion(state, val) {
      state.version = val
    },
    setBrowser(state, val) {
      state.browser = val
    },
    setSwitchMode(state) {
      if (state.user) {
        state.userBuffer = state.user
        state.user = null
        state.snackbar = Object.assign({}, {
          color: "success",
          timeout: 3000,
          text: "Vous êtes en mode visiteur"
        }, { active: true })
      } else {
        state.user = state.userBuffer
        state.userBuffer = null
        state.snackbar = Object.assign({}, {
          color: "success",
          timeout: 3000,
          text: "Vous êtes en mode administrateur"
        }, { active: true })
      }
    },
    setQueries(state, val) {
      state.queries[val] = state.queries[val] + 1
    },
    setImagesSceleton(state, val) {
      state.imagesSceleton = val
    },
    setLoading(state, val) {
      state.loading = val
    },
    setDialogLogin(state, val) {
      state.dialogLogin = val
    },
    setDialogItem(state, val) {
      state.dialogItem = val
    },
    setArrowHelper(state, val) {
      state.arrowHelper = val
    },
    setSnackbar(state, val) {
      state.snackbar = Object.assign({}, val, { active: true })
    },
    setAddItem(state, val) {
      state[val.category].unshift(Object.assign({ uid: val.id }, val.item));
    },
    setDeleteItem(state, val) {
      state[val.category] = state[val.category].filter(function (item) {
        return item.uid != val.id;
      });
    },
    setUpdateItem(state, val) {
      state[val.category] = state[val.category].map(item => (item.uid == val.id) ? Object.assign({ uid: val.id }, val.item) : item)
    },
  },
  actions: {
    getVersion({ state, commit, dispatch }) {
      firebase.firestore().collection("version")
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(function (change) {
              if (change.type === "added") {
                commit('setVersion', change.doc.data().version)
              }
              if (change.type === "modified") {
                commit('setVersion', change.doc.data().version)
              }
            });
          },
          error => {
            console.log(error);
          }
        );
    },
    updateApplication({ state, commit, dispatch }) {
      router.push("/huiles");
      location.reload();
    },
    getAll({ state, commit, dispatch }) {
      // allow write: if request.auth.uid == 'EFTzZbAI17hxkb0vpna8X03WIwg2' || request.auth.uid == 'Y7D6S1IIn7SKNZjTnEMpNVRV0WD3';

      for (let i in state.categories) {
        firebase.firestore().collection(state.categories[i])
          .orderBy("date", "asc")
          // .limit(1)
          .onSnapshot(
            snapshot => {
              snapshot.docChanges().forEach(function (change) {
                if (change.type === "added") {
                  commit('setAddItem', { item: change.doc.data(), id: change.doc.id, category: state.categories[i] })
                }
                if (change.type === "modified") {
                  commit('setUpdateItem', { item: change.doc.data(), id: change.doc.id, category: state.categories[i] })
                }
                if (change.type === "removed") {
                  commit('setDeleteItem', { item: change.doc.data(), id: change.doc.id, category: state.categories[i] })
                }
              });
              commit('setImagesSceleton', false)
            },
            error => {
              console.log(error);
            }
          );
      }
    },
    uploadItem({ state, commit, dispatch }, payload) {
      // { category: payload.category, uid: doc.id, file: payload.event.target.files[0] }
      // commit("setSnackbar", {
      //   color: "success",
      //   timeout: 3000,
      //   text: "Image ajoutée"
      // });
      // var d = new Date(),
      //   month = '' + (d.getMonth() + 1),
      //   day = '' + d.getDate(),
      //   year = d.getFullYear();

      // if (month.length < 2) month = '0' + month;
      // if (day.length < 2) day = '0' + day;

      // File or Blob named mountains.jpg
      var file = payload.file
      // Create the file metadata
      var metadata = {
        contentType: file.type
      };
      // console.log(this.category + "/" + file.name);
      // Upload file and metadata to the object 'images/mountains.jpg'
      var uploadTask = firebase
        .storage()
        .ref()
        .child(payload.category + "_" + payload.uid + "_" + file.name)
        .put(file, metadata);

      // let self = this;
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        "state_changed", // or 'state_changed'
        // function (snapshot) {
        //   // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        //   var progress =
        //     (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        //   // self.uploadPercentage = progress;
        //   switch (snapshot.state) {
        //     case firebase.storage.TaskState.PAUSED: // or 'paused'
        //       // console.log("Upload is paused");
        //       break;
        //     case firebase.storage.TaskState.RUNNING: // or 'running'
        //       // console.log("Upload is running");
        //       break;
        //   }
        // },
        function (error) {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/unauthorized":
              console.log("storage/unauthorized")
              // User doesn't have permission to access the object
              break;

            case "storage/canceled":
              console.log("storage/canceled")
              // User canceled the upload
              break;

            case "storage/unknown":
              console.log("storage/unknown")
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        },
        // function () {
        //   // Upload completed successfully, now we can get the download URL
        //   uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
        //     console.log("File available at", downloadURL);
        //     dispatch("uploadItem", {
        //       downloadURL: downloadURL,
        //       category: payload.category
        //     });
        //   });
        // }
      );
    },
    createItem({ state, commit, dispatch }, payload) {
      commit("setLoading", true)
      if (!payload.event.target.files[0]) return commit("setLoading", false);

      let item = {
        date: new Date().toISOString().substr(0, 10),
        background: 'black'
      }

      firebase.firestore().collection(payload.category).add(item)
        .then(function (doc) {
          // console.log(payload.category)
          // console.log(doc.id)
          // console.log(payload.event.target.files[0])
          commit("setLoading", false)

          dispatch("uploadItem", { category: payload.category, uid: doc.id, file: payload.event.target.files[0] })
          // let newLesson = Object.assign({}, payload, { uid: doc.id })
          // commit("setSnackbar", {
          //   color: "success",
          //   timeout: 3000,
          //   text: "Image ajoutée"
          // });
          // commit("setLoading", false)
        })
        .catch(function (error) {
          // console.log(error)
          commit("setSnackbar", {
            color: "error",
            timeout: 3000,
            text: "Une erreur est survenue"
          });
          commit("setLoading", false)
        });
    },
    deleteItem({ state, commit }, payload) {
      commit("setLoading", true)
      commit("setDialogItem", false)
      // Create a reference to the file to delete
      // console.log(payload)
      if (payload.item.imageName) {
        firebase
          .storage().ref().child(payload.item.imageName).delete().then(function () {
          }).catch(function (error) {
            // Uh-oh, an error occurred!
            commit("setSnackbar", {
              color: "error",
              timeout: 3000,
              text: error
            });
          });
        firebase
          .storage().ref().child(payload.item.thumbnailName).delete().then(function () {
          }).catch(function (error) {
            // Uh-oh, an error occurred!
            console.log(error)
          });
      }


      firebase.firestore().collection(payload.category).doc(payload.item.uid).delete().then(function () {
        commit("setSnackbar", {
          color: "success",
          timeout: 3000,
          text: "Élément supprimé"
        });
        commit("setLoading", false)
      }).catch(function (error) {
        console.log(error)
        commit("setLoading", false)
      });
    },
    updateItem({ state, commit }, payload) {
      commit("setLoading", true)
      commit("setDialogItem", false)
      firebase.firestore().collection(payload.category).doc(payload.item.uid)
        .update(payload.item).then(function () {
          commit("setLoading", false)
          commit("setDialogItem", false)
          commit("setSnackbar", {
            color: "success",
            timeout: 3000,
            text: "Les modifications ont été sauvegardées"
          });
        })
        .catch(err => {
          commit("setLoading", false)
          console.log(err);
        });
    },
  }
})
